export default {
  time_options: {
    asap: {
      title: 'Cât mai curând',
      description: 'Gata în {{time}} min',
    },
    scheduled: {
      title: 'Programați pentru mai târziu',
    },
  },
};
